import { Navigate } from "react-router-dom";
import Loginpage from "../pages/Loginpage";
import useAuthStore from "../store/useAuthStore";
import { getBuilderHomePath } from "../utils/builderNavigation";

const ProtectedLoginRoute = () => {
  const { user, userType, token } = useAuthStore();

  // Check both user and token existence
  if (user && token) {
    // Redirect based on userType
    if (userType === "builder") {
      return <Navigate to={getBuilderHomePath(user)} replace />;
    }
    if (userType === "customer") {
      return <Navigate to="/" replace />;
    }
    if (userType === "agent") {
      return <Navigate to="/agent/housingpost" replace />;
    }
  }

  return <Loginpage />;
};

export default ProtectedLoginRoute;
